import { Header, AllSelected as AllSelectedComponent } from "components"
export const AllSelected = () => {
 return (
  <div>
   <div className="z-10 relative">
    <Header />
   </div>
   <AllSelectedComponent />
  </div>
 )
}
